export const EditIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.002" height="18.003" viewBox="0 0 18.002 18.003">
        <g id="ic_edit_24px" transform="translate(-3 -2.997)">
            <path id="Path_13" data-name="Path 13"
                  d="M3,17.25V21H6.75L17.81,9.94,14.06,6.19ZM20.71,7.04a1,1,0,0,0,0-1.41L18.37,3.29a1,1,0,0,0-1.41,0L15.13,5.12l3.75,3.75,1.83-1.83Z"
                  fill="#50c293"/>
        </g>
    </svg>
)